class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  } 

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    const summary = this.mainDetailsToggle.querySelector('summary');

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleMenu();
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target) && this.mainDetailsToggle.hasAttribute('open')) {
        this.closeMenu();
      }
    });
  }

  toggleMenu() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.onToggle();
    }
  }

  closeMenu() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close(); 
      this.onToggle();
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.mainDetailsToggle.classList.add('menu-open');
      document.body.classList.add('menu-is-open');
    } else {
      this.mainDetailsToggle.classList.remove('menu-open');
      const anyStillOpen =
        document.querySelector('header-menu details[open]') ||
        document.querySelector('menu-drawer details[open]');
      if (!anyStillOpen) {
        document.body.classList.remove('menu-is-open');
      }
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }
}

customElements.define('header-menu', HeaderMenu);



